import {useQuery} from '@tanstack/react-query';
import useSearchParam from 'src/hooks/useSearchParam';
import {getListQuery} from 'src/utils/queries';
import fetcher from 'src/utils/fetcher';

const useMapSelectedPlacesList = () => {
  const [placesListQuery] = useSearchParam('places-list');

  const isTop100 = placesListQuery === 'top100';

  const {data: humboList, isFetching: isFetchingHumboList} = useQuery<HumboList>({
    queryKey: ['list', placesListQuery],
    queryFn: () => fetcher(getListQuery('humbo', placesListQuery, {numberOfImagesToLoad: 1, skipArticleFields: true})),
    enabled: Boolean(placesListQuery && !isTop100)
  });

  const {data: top100Places = [], isFetching: fetchingTop100List} = useQuery<Place[]>({
    queryKey: ['top100WithLocation'],
    queryFn: () => fetcher({url: '/api/places/top', query: {limit: 100, withLocation: true}}),
    enabled: Boolean(placesListQuery && isTop100)
  });

  const top100List: HumboList = {
    _id: 'top100',
    name: 'Top 100 places to visit in the world',
    nameId: 'top100',
    dateCreated: new Date(),
    dateUpdated: new Date(),
    user: 'humbo',
    places: top100Places.map((place) => ({place, dateAdded: new Date()}))
  };

  const isFetching = isFetchingHumboList || fetchingTop100List;
  const placesList = isTop100 ? top100List : humboList;

  return {placesList, isFetching};
};

export default useMapSelectedPlacesList;
